export class AppConstants {
  static readonly NUM_PAGES = 100; //Es el numero máximo de paginas por lote
  static readonly ROWS_PER_PAGE = 15; //Es la cantidad de registros por página
  static readonly MAX_ROWS_PER_BATCH = 1501; //Es el tamaño máximo del lote
  static readonly FIRST_PAGE = 1; //Indica el numero de la primer página
  static readonly DIFF_PAGE = 2; //Es la diferencia de paginas (arriba/abajo) que se visualizan en el paginador
  static readonly MAX_PAGE_VIEW = 5; //Es la cantidad máxima de paginas del paginador
  static readonly MAX_ROWS_PER_REPORT_VALIDATE = 10000000 //Es la cantidad máxima de registros por reporte, 10 Millones
  static readonly MAX_ROWS_PER_EXCEL = 700000 //Es la cantidad máxima de registros por reporte, 10 Millones

  //Reglas Info Avisos
  static readonly REGLAS_AVISO = `<b>Generación de Aviso</b>
  • El aviso se generará de forma mensual como máximo los días 17 de cada mes.
  • El reporte se genera de forma mensual (Mes vencido inmediato anterior)
  Ejemplo: Si selecciona "Agosto" el sistema buscará casos generados del 01 de Marzo al 31 de Agosto

  • NOTA: Una vez que el SAT haya aceptado el aviso se debera realizar la búsqueda nuevamente y seleccionar el botón "Finalizar y Reportar" para que estas operaciones no aparezcan nuevamente en avisos futuros`;
  
  static readonly REGLAS_INUSUAL = `<b>Generación de Reportes Inusuales</b>
  • El reporte contempla solo casos generados en alertas inusuales.
  • El reporte se genera de forma mensual
  Ejemplo: Si selecciona "Septiembre" el sistema buscará casos generados del 01 de Sep al 30 de Sep`;
  
  static readonly REGLAS_INUSUAL24 = `<b>Generación de Reporte Inusuales 24 Hrs</b>
  • El reporte contempla solo casos generados en alertas inusuales marcados como 24 Horas.
  • El reporte se genera de forma mensual
  Ejemplo: Si selecciona "Septiembre" el sistema buscará casos generados del 01 de Sep al 30 de Sep`;
}
